import { useMemo } from "react";

import { createResourceStorageKeys } from "src/framework/createResourceStorageKeys.ts";

export const useResourceStorageKeys = ({ resource }: { resource: string }) => {
  return useMemo(
    () =>
      createResourceStorageKeys({
        resource,
      }),
    [resource],
  );
};
